import { render, staticRenderFns } from "./WaffGComplianceDashboard.vue?vue&type=template&id=8facffcc&scoped=true"
import script from "./WaffGComplianceDashboard.vue?vue&type=script&lang=js"
export * from "./WaffGComplianceDashboard.vue?vue&type=script&lang=js"
import style0 from "./WaffGComplianceDashboard.vue?vue&type=style&index=0&id=8facffcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8facffcc",
  null
  
)

export default component.exports